import { firestore, functions } from '@/firebaseConfig'
import MapObject from '@/model/MapObject';
import UUIDUtils from '@/utils/UUIDUtils';
import LangUtils from '@/utils/LangUtils';

export default class MapObjectService {

    loadMapObject(publisherId, mapObjectId) {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).collection("mapObjects").doc(mapObjectId).get().then((doc) => {
                if (doc.exists) {
                  resolve(new MapObject(doc.data()));
                } else {
                  resolve(null);
                }
            }).catch((error) => {
                console.log("DEBUG : " + error)
                reject(error);
            });
        });

        return promise;
    }

    deleteMapObject(publisherId, mapObjectId) {
        const promise = new Promise((resolve, reject) => {
            const deleteField = {
                toDelete: true
            };
            firestore.collection("publishers").doc(publisherId).collection("mapObjects").doc(mapObjectId).update(deleteField).then(() => {
                resolve();
            }).catch((error) => {
                console.error("Error deleting map object:", error);
                reject(error);
            });
        });

        return promise;
    }
}
